import React from "react";

// Shimmer skeleton shown while the dashboard data loads — mirrors the KPI grid + chart
// layout so there's no jump when the real cards render. Purely presentational.

const KpiSkeletonCard: React.FC = () => (
    <div className="po-card po-kpi po-skel-card" aria-hidden="true">
        <span className="po-skel po-skel--label" />
        <span className="po-skel po-skel--value" />
        <span className="po-skel po-skel--line" />
        <span className="po-skel po-skel--line po-skel--line-sm" />
    </div>
);

const DashboardSkeleton: React.FC = () => (
    <>
        <div className="po-kpis" aria-busy="true">
            {Array.from({ length: 6 }).map((_, i) => (
                <KpiSkeletonCard key={i} />
            ))}
        </div>

        <div className="po-card po-chart-card po-skel-card" aria-hidden="true">
            <span className="po-skel po-skel--label" />
            <div className="po-skel-bars">
                {Array.from({ length: 6 }).map((_, i) => (
                    <span className="po-skel po-skel--bar" key={i} style={{ width: `${92 - i * 12}%` }} />
                ))}
            </div>
        </div>
    </>
);

export default DashboardSkeleton;
